import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
// import InstructionsOutline from './components/InstructionsOutline';
import InstructionsHeader from './components/InstructionsHeader';
import parse from 'html-react-parser';
import Timer from './components/Timer';
import MediaSlider from './components/MediaSlider';
import './scss/Instructions.scss';

function Instructions({ instructions, sectionsStateInit }) {
  // Section state (collapsed/expanded, display/hide video)
  const [sectionsState, setSectionsState] = useState(sectionsStateInit);

  // observes if the top of the <Instructions> section is above
  // the vertical midpoint of the screen
  const [ ref1, inView ] = useInView({
    rootMargin: "0px 0px -50% 0px",
  });

  // observes if the top of the <Instructions> section is above
  // the vertical midpoint of the screen
  // const [ ref2, belowTop ] = useInView({
  //   rootMargin: "10% 0px -110% 0px",
  // });

  // if the recipe gets filtered so that the # of ingredients lists changes
  // or the # of steps change, need to reinitialize sectionsState
  useEffect(() => {
    setSectionsState(sectionsStateInit)
    // need to add code here to re-expand sections on desktop, or when less than 3
    // see useEffect hook on line #49
  }, [sectionsStateInit])

  // check the state of a given section
  function ckSt(id, prop) {
    return sectionsState.find(item => item.id === id)?.[prop]
  }

  // find the index of the section that was clicked on
  function currIndex(e) {
    const id = e.currentTarget.closest('section').id;
    const sectionIndex = sectionsState.findIndex(obj => obj.id === id);
    return sectionIndex
  }

  // expand all sections on initial load if:
  // - screen is wider than 1199px (on initial load)
  // - there are less than 3 sections
  useEffect(() => {
    if (window.innerWidth > 1199 || instructions.length < 3) {
      setSectionsState(
        sectionsState.map(section => {
          return { ...section, isCollapsed: false };
        })
      )
    }
  }, []);

  // expand/collapse individual section
  function toggleSection(e) {
    setSectionsState(
      // create a new array with updates
      sectionsState.map((section, index) => {
        if (index === currIndex(e)) {
          // toggle isCollapsed
          return { ...section, isCollapsed: !section.isCollapsed };
        } else {
          return section;
        }
      })
    )
  }

  // toggle video (section)
  function toggleVideosBySection(e) {
    setSectionsState(
      // create a new array with updates
      sectionsState.map((section, index) => {
        if (index === currIndex(e)) {
          // toggle displayVideos
          return { ...section, displayVideos: !section.displayVideos };
        } else {
          return section;
        }
      })
    )
  }

  // in Cook Mode you can select an instruction step
  // this value is also passed to <ImageSlider/> to determine which image to show
  function selectStep(e) {
    const sectionIndex = currIndex(e);
    const stepIndex = parseInt(e.currentTarget.getAttribute('data-index'));

    setSectionsState(
      sectionsState.map((item, index) => {
        // If the current index matches the provided index, update the selectedStep
        // Otherwise, set the selectedStep to null
        const selectedStep = index === sectionIndex ? stepIndex : null;
    
        // Return a new object with the updated selectedStep
        return { ...item, selectedStep };
      })
    )
  }

  return (
    <section id="instructions" ref={ref1}>
      {/* {belowTop && <InstructionsOutline instructions={instructions} />} */}
      <InstructionsHeader
        sectionsState={sectionsState}
        setSectionsState={setSectionsState}
        inView={inView}
      />
      <div 
        id="instructions-content"
        // ref={ref2}
      >
        {instructions.map((section, sectionIndex) =>
          <section 
            id={section.id} 
            key={section.id}
            className={`sub-section collapsible ${section.media ? "hasMedia" : ""}`}
            data-collapsed={ckSt(section.id, 'isCollapsed')}
            data-display-videos={ckSt(section.id, 'displayVideos')}
          >
            {section.name 
              && <h3 className="section-header" onClick={toggleSection}>{section.name}</h3>
            }
            <div className="section-content">
              <ul className={`text ${section.id}-steps`}>
                {section.steps.map((step, stepIndex) =>
                  <div 
                    className="step" 
                    key={stepIndex} 
                    data-index={stepIndex}
                    data-selected={sectionsState[sectionIndex]?.selectedStep === stepIndex} 
                    onClick={selectStep}
                  >
                    <div className="marker">{stepIndex+1}</div>
                    <li>
                      <span>{parse(step.text)}</span>
                      {step.timer && <Timer minutes={step.timer * 60} />}
                      {step.note && <p className="step-note">{step.note}</p>}
                    </li>
                  </div>
                )}
              </ul>
              {section.media && 
                <div className="media">
                  <MediaSlider 
                    media={section.media}
                    step={sectionsState[sectionIndex].selectedStep}
                  />
                </div>
              }
            </div>
          </section>
        )}
      </div>
    </section>
  );
}

export default Instructions;
